export { default as fetchFooter } from "./fetchFooter/fetchFooter";
export { default as fetchHomeSections } from "./fetchHomeSections/fetchHomeSections";
export { default as fetchLogo } from "./fetchLogo/fetchLogo";
